define('app',['require','exports','module','underscore','jquery','backbone'],function(require, exports, module) {
	
	"use strict";

	// External dependencies.
	var _ = require("underscore");
	var $ = require("jquery");
	var Backbone = require("backbone");
	
	
		
	

	var app = module.exports;

	app.root = "/";
	
	var alertFallback = true;

});

